export const schedule: Record<string, string> = {
  'Always require for this shift': 'Toujours exiger pour cette vacation',
  'Disable for this shift': 'Désactiver pour cette vacation',
  'Failed to update shift welfare policy': 'Impossible de mettre à jour la politique de bien-être de la vacation',
  'Required': 'Obligatoire',
  'Site default': 'Valeur par défaut du site',
  'Use site policy': 'Utiliser la politique du site',
  'Welfare': 'Bien-être',
  'Help': 'Aide',
  'Build a guard roster': 'Créer un planning des agents',
  'Use the Duty Board to plan coverage for each client site, assign eligible guards, and publish shifts to the guard app.': 'Utilisez le tableau de service pour planifier la couverture de chaque site client, affecter les agents admissibles et publier les vacations dans l’application des agents.',
  'Choose the scope': 'Choisir le périmètre',
  'Client, site and date': 'Client, site et date',
  'Choose a client and site, move between dates, and switch between the detailed day view and the weekly overview.': 'Choisissez un client et un site, parcourez les dates et basculez entre la vue journalière détaillée et la vue hebdomadaire.',
  'Draft or live': 'Brouillon ou publié',
  'Know what guards can see': 'Savoir ce que voient les agents',
  'The status explains whether this roster is still a draft, is live for guards, or has unpublished changes.': 'Le statut indique si ce planning est encore un brouillon, s’il est visible par les agents ou s’il contient des modifications non publiées.',
  'Plan coverage': 'Planifier la couverture',
  'Create duties and breaks': 'Créer des services et des pauses',
  'Add duty and break blocks, then drag or resize them on the timeline. Select a duty to edit its type, times, location, licence requirement, and staffing.': 'Ajoutez des blocs de service et de pause, puis déplacez-les ou redimensionnez-les sur la chronologie. Sélectionnez un service pour modifier son type, ses horaires, son emplacement, la licence requise et son effectif.',
  'Staff the roster': 'Affecter le personnel',
  'Assign eligible guards': 'Affecter les agents admissibles',
  'Open the Guards panel to search your team. Drag an available guard onto a duty or break; licence, leave, and published-shift conflicts keep unavailable guards clearly separated.': 'Ouvrez le volet Agents pour rechercher votre équipe. Faites glisser un agent disponible sur un service ou une pause ; les conflits de licence, de congé et de vacation publiée distinguent clairement les agents indisponibles.',
  'Go live': 'Publier',
  'Publish when ready': 'Publier lorsque tout est prêt',
  'Publishing makes assigned shifts visible to guards. If you edit a live roster, publish it again so guards receive the latest changes.': 'La publication rend les vacations affectées visibles par les agents. Si vous modifiez un planning publié, republiez-le pour transmettre les dernières modifications.',
  'Ready to roster': 'Prêt à planifier',
  'Your schedule workflow': 'Votre processus de planification',
  'Choose the site and date, add coverage, assign guards, review warnings, then publish. Use Help on this page whenever you need a refresher.': 'Choisissez le site et la date, ajoutez la couverture, affectez les agents, examinez les avertissements, puis publiez. Utilisez l’aide de cette page pour revoir ces étapes.',
  'Add a duty': 'Ajouter un service',
  'Add a note (optional)...': 'Ajouter une note (facultatif)...',
  'Add another break like this': 'Ajouter une pause identique',
  'Add break': 'Ajouter une pause',
  'Add Leave': 'Ajouter un congé',
  'Admin note': 'Note administrateur',
  'Admin notes (optional)': 'Notes administrateur (facultatif)',
  'Approved': 'Approuvé',
  'Assign guard': 'Affecter un agent',
  'Assign guard to break': 'Affecter un agent à la pause',
  'Assign guards who should take this break.':
    'Affectez les agents qui doivent prendre cette pause.',
  'Assigned': 'Affecté',
  'Assigned guards': 'Agents affectés',
  'Back to roster': 'Retour au planning',
  'Break actions': 'Actions sur la pause',
  'Breaks': 'Pauses',
  'Cancelled': 'Annulé',
  'Choose a site to inspect shifts.': 'Choisissez un site pour consulter les vacations.',
  'Choose site country': 'Choisir le pays du site',
  'Clear all duties': 'Effacer tous les services',
  'Close guards panel': 'Fermer le volet des agents',
  'Close inspector': 'Fermer le volet d’inspection',
  'Color': 'Couleur',
  'Copy this day\'s duties': 'Copier les services de cette journée',
  'Create leave entry': 'Créer une entrée de congé',
  'Day': 'Jour',
  'Day window toggle': 'Sélecteur de plage journalière',
  'Delete all breaks in row': 'Supprimer toutes les pauses de la ligne',
  'Delete duty': 'Supprimer le service',
  'Denied': 'Refusé',
  'Dismiss': 'Ignorer',
  'Drag an available guard onto a duty or break.':
    'Faites glisser un agent disponible sur un service ou une pause.',
  'Draft': 'Brouillon',
  'Drop guard': 'Retirer l’agent',
  'Duration (minutes)': 'Durée (minutes)',
  'Duties': 'Services',
  'Duties board': 'Tableau de service',
  'From previous day': 'Suite de la veille',
  'Duty board staffing': 'Effectifs du tableau de service',
  'Duty color': 'Couleur du service',
  'Duty location': 'Lieu du service',
  'e.g. Family vacation, medical appointment...':
    'p. ex. vacances en famille, rendez-vous médical...',
  'Edit duty times': 'Modifier les horaires du service',
  'End': 'Fin',
  'End time': 'Heure de fin',
  'Fill empty days': 'Remplir les jours vides',
  'Gaps': 'Lacunes',
  'Guard Search': 'Recherche d’agents',
  'Hover a guard to see why they are unavailable.':
    'Survolez un agent pour connaître la raison de son indisponibilité.',
  'Internal notes visible only to admins...':
    'Notes internes visibles uniquement par les administrateurs...',
  'Leave & Availability': 'Congés et disponibilités',
  'Leave type': 'Type de congé',
  'Licence': 'Licence',
  'Licence required': 'Licence requise',
  'Loading leave requests...': 'Chargement des demandes de congé...',
  'Loading roster...': 'Chargement du planning...',
  'Loading shifts...': 'Chargement des vacations...',
  'Loading week...': 'Chargement de la semaine...',
  'Manually log leave for a guard. This will be auto-approved since it is entered by an admin.':
    'Enregistrez manuellement le congé d’un agent. Il sera automatiquement approuvé puisqu’il est saisi par un administrateur.',
  'Merged guard shifts': 'Vacations consolidées des agents',
  'No clients': 'Aucun client',
  'No duties for this day yet.': 'Aucun service pour cette journée pour le moment.',
  'No eligible guards for this duty.': 'Aucun agent admissible pour ce service.',
  'No guard assigned': 'Aucun agent affecté',
  'No guards match that search': 'Aucun agent ne correspond à cette recherche',
  'No licence': 'Aucune licence',
  'No sites': 'Aucun site',
  'No unavailable guards for this view.': 'Aucun agent indisponible dans cette vue.',
  'Not live': 'Non publié',
  'Off roster': 'Hors planning',
  'Open day view': 'Ouvrir la vue journalière',
  'Override and publish': 'Ignorer les avertissements et publier',
  'Past day &#8212; view only': 'Jour passé — lecture seule',
  'Paste': 'Coller',
  'Paste copied duties here': 'Coller les services copiés ici',
  'Pending': 'En attente',
  'Publication blocked': 'Publication bloquée',
  'Published': 'Publié',
  'Remove break': 'Supprimer la pause',
  'Requests': 'Demandes',
  'Review and action guard leave requests, or manually add leave entries for vacation, sickness, or other absences.':
    'Examinez et traitez les demandes de congé des agents, ou ajoutez manuellement des congés, arrêts maladie ou autres absences.',
  'Roster rule warnings': 'Avertissements sur les règles du planning',
  'Roster rules': 'Règles du planning',
  'Save times': 'Enregistrer les horaires',
  'Schedule leave': 'Planifier un congé',
  'Schedule shifts': 'Planifier des vacations',
  'Search by guard name': 'Rechercher par nom d’agent',
  'Search for a guard, switch between day and week, and inspect the merged duty and break flow that each guard will see once the roster is published.':
    'Recherchez un agent, basculez entre le jour et la semaine, puis examinez la séquence consolidée des services et des pauses que chaque agent verra une fois le planning publié.',
  'Search guards': 'Rechercher des agents',
  'Search guards...': 'Rechercher des agents...',
  'Segments': 'Segments',
  'Select a guard...': 'Sélectionner un agent...',
  'Set the break length. You can drag and reposition the break block on the timeline after creating it.':
    'Définissez la durée de la pause. Après sa création, vous pouvez faire glisser et repositionner le bloc de pause sur la chronologie.',
  'Split': 'Fractionné',
  'Start': 'Début',
  'Start time': 'Heure de début',
  'Time': 'Heure',
  'Times': 'Horaires',
  'Try a different name or clear the search to see the full roster again.':
    'Essayez un autre nom ou effacez la recherche pour afficher de nouveau tout le planning.',
  'Unavailable': 'Indisponible',
  'Unavailable guards': 'Agents indisponibles',
  'Undo edits': 'Annuler les modifications',
  'Unfilled guard slot': 'Poste d’agent non pourvu',
  'Use 15-minute increments. The end time can be set to 24:00.':
    'Utilisez des intervalles de 15 minutes. L’heure de fin peut être réglée sur 24:00.',
  'Use the action bar below to add your first duty or break.':
    'Utilisez la barre d’actions ci-dessous pour ajouter votre premier service ou votre première pause.',
  'Warnings': 'Avertissements',
  'Week': 'Semaine',
  'Weekly duties': 'Services de la semaine',
  'Add duties and breaks, then publish the day before guards can see assigned shifts.':
    'Ajoutez des services et des pauses, puis publiez la journée pour que les agents puissent voir leurs vacations.',
  'Annual leave': 'Congé annuel',
  'Assigned guard': 'Agent affecté',
  'Break added': 'Pause ajoutée',
  'Break details': 'Détails de la pause',
  'Break does not fit within the site coverage window.':
    'La pause ne tient pas dans la plage de couverture du site.',
  'Break removed': 'Pause supprimée',
  'Break times must stay inside the site coverage window.':
    'Les horaires de pause doivent rester dans la plage de couverture du site.',
  'Changes create a draft. Publish again to make them live, or undo to restore the published roster.':
    'Les modifications créent un brouillon. Publiez de nouveau pour les rendre visibles, ou annulez-les pour restaurer le planning publié.',
  'Changes not live': 'Modifications non publiées',
  'Clipboard is from a different site. Copy again from the current site.':
    'Le presse-papiers provient d’un autre site. Effectuez une nouvelle copie depuis le site actuel.',
  'Confirm publish': 'Confirmer la publication',
  'Confirming publish makes assigned shifts visible to guards.':
    'La confirmation de la publication rend les vacations affectées visibles par les agents.',
  'Create {kind}': 'Créer : {kind}',
  'Custom': 'Personnalisé',
  'Day cleared': 'Journée effacée',
  'Day published - guards can now see assigned shifts':
    'Journée publiée — les agents peuvent maintenant voir leurs vacations',
  'Day published with roster warnings flagged':
    'Journée publiée avec des avertissements de planning signalés',
  'Desk': 'Bureau',
  'Draft - not live': 'Brouillon — non publié',
  'Draft changes are not live. Press Edit to adjust them, publish to go live, or undo current edit-session changes.':
    'Les modifications du brouillon ne sont pas visibles. Cliquez sur Modifier pour les ajuster, publiez-les pour les rendre visibles ou annulez les modifications de cette session.',
  'Draft roster': 'Planning provisoire',
  'Duration must be between 5 and 480 minutes.':
    'La durée doit être comprise entre 5 et 480 minutes.',
  'Duration must be in 5-minute increments.':
    'La durée doit être définie par intervalles de 5 minutes.',
  'Duty added': 'Service ajouté',
  'Duty details': 'Détails du service',
  'Duty must be at least 60 minutes to split.':
    'Le service doit durer au moins 60 minutes pour être fractionné.',
  'Duty removed': 'Service supprimé',
  'Duty split': 'Service fractionné',
  'Duty times must stay inside the site coverage window.':
    'Les horaires du service doivent rester dans la plage de couverture du site.',
  'Duty times updated': 'Horaires du service mis à jour',
  'Edit cancelled': 'Modification annulée',
  'Editing published': 'Modification de la version publiée',
  'Editing published roster': 'Modification du planning publié',
  'Edits undone - published roster restored':
    'Modifications annulées — planning publié restauré',
  'End date must be on or after start date':
    'La date de fin doit être identique ou postérieure à la date de début',
  'Fully staffed': 'Effectif complet',
  'Guard assigned': 'Agent affecté',
  'Guard assigned to break': 'Agent affecté à la pause',
  'Guard removed': 'Agent retiré',
  'Guard removed from break': 'Agent retiré de la pause',
  'Guards can see this roster. Press Edit before changing duties, breaks, or assignments.':
    'Les agents peuvent voir ce planning. Cliquez sur Modifier avant de changer les services, les pauses ou les affectations.',
  'Historic roster is read-only': 'Le planning historique est en lecture seule',
  'Mobile': 'Mobile',
  'Needs staff': 'Effectif requis',
  'No empty days to fill': 'Aucune journée vide à remplir',
  'No roster': 'Aucun planning',
  'No roster items yet': 'Aucun élément de planning pour le moment',
  'No space to add another break in this coverage window.':
    'Aucun créneau disponible pour ajouter une pause dans cette plage de couverture.',
  'Not enough space to place the block there.':
    'L’espace est insuffisant pour placer le bloc à cet endroit.',
  'Other': 'Autre',
  'Patrol||duty kind': 'Ronde',
  'Please select a guard': 'Veuillez sélectionner un agent',
  'Post': 'Poste',
  'Publication blocked by roster rule warnings':
    'Publication bloquée par des avertissements sur les règles du planning',
  'Publish again so guards see the latest duty, break, and assignment changes.':
    'Publiez de nouveau pour que les agents voient les dernières modifications des services, pauses et affectations.',
  'Publish day': 'Publier la journée',
  'Publish this day to make assigned shifts live for guards.':
    'Publiez cette journée pour rendre les vacations affectées visibles par les agents.',
  'Published - live': 'Publié — visible',
  'Published roster has draft changes': 'Le planning publié comporte des modifications provisoires',
  'Published roster is locked. Press Edit to make changes.':
    'Le planning publié est verrouillé. Cliquez sur Modifier pour apporter des changements.',
  'Published roster locked': 'Planning publié verrouillé',
  'Published roster unlocked for editing': 'Planning publié déverrouillé pour modification',
  'Published roster updated - guards can see the latest shifts':
    'Planning publié mis à jour — les agents peuvent voir les dernières vacations',
  'Roster published - guards can now see assigned shifts':
    'Planning publié — les agents peuvent maintenant voir leurs vacations',
  'Roster published with warnings flagged for admins':
    'Planning publié avec des avertissements signalés aux administrateurs',
  'Route assigned': 'Itinéraire affecté',
  'Select {kind}': 'Sélectionner : {kind}',
  'Selected {kind}': '{kind} sélectionné',
  'Sick leave': 'Congé maladie',
  'Split would create a segment shorter than 30 minutes.':
    'Le fractionnement créerait un segment de moins de 30 minutes.',
  'Staffing - {assigned}/{required}': 'Effectif — {assigned}/{required}',
  'Unpaid leave': 'Congé sans solde',
  'Unstaffed': 'Sans effectif',
  'Update published': 'Mettre à jour la version publiée',
  'no guard': 'aucun agent',
  'patrol route': 'itinéraire de ronde',
  'per-guard breaks': 'pauses par agent',
  'post': 'poste',
  'Open originating day': 'Ouvrir le jour precedent',
  'Staffing': 'Effectifs',
  'unassigned': 'non affecté',
  '{assigned}/{required} assigned': '{assigned}/{required} affectés',
  '{count} assigned': '{count} affectés',
  '{count} duties · {hours}h': '{count} services · {hours} h',
  '{count} gap': '{count} lacune',
  '{count} gaps': '{count} lacunes',
  '{count} warning flagged on this published roster after override.':
    '{count} avertissement signalé sur ce planning publié après dérogation.',
  '{count} warnings flagged on this published roster after override.':
    '{count} avertissements signalés sur ce planning publié après dérogation.',
  '{count} warning flagged on this published roster.':
    '{count} avertissement signalé sur ce planning publié.',
  '{count} warnings flagged on this published roster.':
    '{count} avertissements signalés sur ce planning publié.',
  '{count} warning must be fixed or overridden before publishing.':
    '{count} avertissement doit être corrigé ou ignoré avant la publication.',
  '{count} warnings must be fixed or overridden before publishing.':
    '{count} avertissements doivent être corrigés ou ignorés avant la publication.',
  '{type} for {name} has been created and approved.':
    'Le congé « {type} » de {name} a été créé et approuvé.',
  // Guard view
  'Add': 'Ajouter',
  'Add guard to board': 'Ajouter un agent au tableau',
  'Already on this duty.': 'Déjà affecté à ce service.',
  'Assign a guard to a duty, or use + Guard below to put someone on the board.':
    'Affectez un agent à un service, ou utilisez « + Agent » ci-dessous pour en ajouter un au tableau.',
  'Assign to duty': 'Affecter à un service',
  'Available': 'Disponible',
  'Board view': 'Vue du tableau',
  'Break moved to {name}': 'Pause transférée à {name}',
  'Double-booked: {first} and {second}': 'Double affectation : {first} et {second}',
  'Drag a duty here to assign {name}': 'Faites glisser un service ici pour affecter {name}',
  'Every guard is already on the board.': 'Tous les agents sont déjà sur le tableau.',
  'No guards on the board yet.': 'Aucun agent sur le tableau pour le moment.',
  'No other duties today.': 'Aucun autre service aujourd’hui.',
  'Reassigned to {name}': 'Réaffecté à {name}',
  'Rows are duties': 'Les lignes sont des services',
  'clash': 'conflit',
  'duty': 'service',
  'free': 'libre',
  '{count} guard on board': '{count} agent sur le tableau',
  '{count} guards on board': '{count} agents sur le tableau',
  '{name} added to the board': '{name} ajouté au tableau',
  // Per-guard break controls
  'Add a break for this guard': 'Ajouter une pause pour cet agent',
  'Edit break': 'Modifier la pause',
  'No free window inside this duty for a {count} minute break.':
    'Aucun créneau libre dans ce service pour une pause de {count} minutes.',
  'unpaid': 'non rémunérée',
  '{count}m': '{count} min',
  '{duration} min {kind} · {start}–{end}': '{duration} min {kind} · {start}–{end}',
  'Today': 'Aujourd’hui',

  // Duty board — per-row blocks, the copy prompt, and the published-roster lock
  'Add another block to {name}': 'Ajouter un autre bloc à {name}',
  'Add another block to {name} — cover a different time with a different guard':
    'Ajouter un autre bloc à {name} — couvrir une autre plage horaire avec un autre agent',
  'Also copy guard assignments?': 'Copier aussi les affectations d’agents ?',
  'Block added to {name} - assign a guard for this window':
    'Bloc ajouté à {name} — affectez un agent pour cette plage',
  'Carries {count} guard assignment over to each day you paste into.':
    'Reporte {count} affectation d’agent sur chaque jour collé.',
  'Carries {count} guard assignments over to each day you paste into.':
    'Reporte {count} affectations d’agents sur chaque jour collé.',
  'Copied with guard assignments - pick the day(s) to paste into':
    'Copié avec les affectations d’agents — choisissez le ou les jours où coller',
  'Copied without guard assignments - pick the day(s) to paste into':
    'Copié sans les affectations d’agents — choisissez le ou les jours où coller',
  'Copies the shape of the day - every block starts unassigned.':
    'Copie la structure de la journée — chaque bloc démarre sans affectation.',
  'Copy {date}': 'Copier {date}',
  'Draft - guards cannot see this day': 'Brouillon — les agents ne voient pas cette journée',
  'Duties and guards': 'Services et agents',
  'Duties only': 'Services uniquement',
  'Guards can already see these shifts, so the board is read-only. Unlock it to change duties, breaks or guards.':
    'Les agents voient déjà ces vacations, le tableau est donc en lecture seule. Déverrouillez-le pour modifier les services, les pauses ou les agents.',
  'Guards can see these shifts. Unlock the day to change it.':
    'Les agents voient ces vacations. Déverrouillez la journée pour la modifier.',
  'Guards see the published version. Unlock the board to keep editing, then publish again.':
    'Les agents voient la version publiée. Déverrouillez le tableau pour poursuivre les modifications, puis publiez de nouveau.',
  'Guards still see the last published version. Publish to push your changes.':
    'Les agents voient toujours la dernière version publiée. Publiez pour transmettre vos modifications.',
  'Guards still see the published roster. Publish to push your changes, or undo to restore it.':
    'Les agents voient toujours le planning publié. Publiez pour transmettre vos modifications ou annulez pour le restaurer.',
  'Historic rosters cannot be changed. Open today or a future day to make edits.':
    'Les plannings passés ne peuvent pas être modifiés. Ouvrez aujourd’hui ou une journée à venir pour les modifier.',
  'Locked - published to guards': 'Verrouillé — publié aux agents',
  'Make your changes, then publish again. Undo restores the published roster at any time.':
    'Effectuez vos modifications, puis publiez de nouveau. Annuler restaure le planning publié à tout moment.',
  'No free time left on this duty row. Shorten a block to make room.':
    'Plus de plage libre sur cette ligne de service. Raccourcissez un bloc pour faire de la place.',
  'Nothing here reaches the guard app until you publish this day.':
    'Rien n’est transmis à l’application des agents tant que cette journée n’est pas publiée.',
  'Nothing scheduled yet': 'Rien de planifié pour le moment',
  'Past day - read only': 'Journée passée — lecture seule',
  'Paste + guards': 'Coller + agents',
  'Paste the copied duties and their guards here': 'Coller ici les services copiés et leurs agents',
  'Paste the copied duties and their guards into every empty day this week':
    'Coller les services copiés et leurs agents dans chaque journée vide de la semaine',
  'Paste the copied duties and their guards into this day':
    'Coller les services copiés et leurs agents dans cette journée',
  'Paste the copied duties here, unassigned': 'Coller ici les services copiés, sans affectation',
  'Paste the copied duties into every empty day this week, unassigned':
    'Coller les services copiés dans chaque journée vide de la semaine, sans affectation',
  'Paste the copied duties into this day, unassigned':
    'Coller les services copiés dans cette journée, sans affectation',
  'Pasted days always arrive as drafts, so nothing reaches guards until you publish.':
    'Les journées collées arrivent toujours en brouillon : rien n’atteint les agents avant publication.',
  'Pasted duties and guard assignments to {days}': 'Services et affectations d’agents collés sur {days}',
  'Pasted duties to {days} - no guards assigned': 'Services collés sur {days} — aucun agent affecté',
  'Press Confirm publish once more to make these shifts visible to guards.':
    'Appuyez de nouveau sur Confirmer la publication pour rendre ces vacations visibles par les agents.',
  'Published - locked': 'Publié — verrouillé',
  'Published and live - the board is locked': 'Publié et visible — le tableau est verrouillé',
  'Published and locked - unlock the day to change this block':
    'Publié et verrouillé — déverrouillez la journée pour modifier ce bloc',
  'Published and locked - with unpublished changes':
    'Publié et verrouillé — avec des modifications non publiées',
  'Read only': 'Lecture seule',
  'Skipped {count} historic day': '{count} journée passée ignorée',
  'Skipped {count} historic days': '{count} journées passées ignorées',
  'This day has no guards assigned yet.': 'Aucun agent n’est encore affecté à cette journée.',
  'This roster is published': 'Ce planning est publié',
  'Unlock to edit': 'Déverrouiller pour modifier',
  'Unlocked - not live': 'Déverrouillé — non visible',
  'Unlocked - your changes are not live yet': 'Déverrouillé — vos modifications ne sont pas encore visibles',
  'Unlocked for editing': 'Déverrouillé pour modification',
  'Unpublished changes - guards still see the old roster':
    'Modifications non publiées — les agents voient toujours l’ancien planning',
  '{count} block': '{count} bloc',
  '{count} blocks': '{count} blocs',
  '{count} day': '{count} jour',
  '{count} days': '{count} jours',
  '{count} duties': '{count} services',
  '{count} duty': '{count} service',
  '{count} guard assignment': '{count} affectation d’agent',
  '{count} guard assignments': '{count} affectations d’agents',
  // ── Roster rule fixes (pages/schedule/compliance) ──────────────────────────
  '(opens in a new tab)': '(s’ouvre dans un nouvel onglet)',
  'Add a {duration} break at {range}': 'Ajouter une pause de {duration} ({range})',
  'After': 'Après',
  'Already cleared by your fix for {issue}.': 'Déjà résolu par votre correction pour {issue}.',
  'Applying…': 'Application…',
  'Average weekly hours over the limit': 'Moyenne hebdomadaire d’heures au-dessus de la limite',
  'Before': 'Avant',
  'Break too short': 'Pause insuffisante',
  'Changed': 'Modifié',
  'Changed duties and breaks go back to draft. Guards see them once you publish the day again.':
    'Les services et pauses modifiés repassent en brouillon. Les agents les verront une fois la journée republiée.',
  'Changes applied. {count} breach remains.': 'Modifications appliquées. {count} manquement subsiste.',
  'Changes applied. {count} breaches remain.': 'Modifications appliquées. {count} manquements subsistent.',
  'Checked against the same rules that publishing uses.': 'Vérifié avec les mêmes règles que la publication.',
  'Checking these changes together against the roster rules…':
    'Vérification de l’ensemble de ces modifications au regard des règles de planning…',
  'Choose fixes': 'Choisir les corrections',
  'Confirm and apply {count} change': 'Confirmer et appliquer {count} modification',
  'Confirm and apply {count} changes': 'Confirmer et appliquer {count} modifications',
  'Does not fix this breach': 'Ne corrige pas ce manquement',
  'Each suggestion is checked against the roster rules before you see it.':
    'Chaque suggestion est vérifiée au regard des règles de planning avant de vous être proposée.',
  'Everyone else on this roster is unchanged.': 'Les autres agents de ce planning ne sont pas modifiés.',
  'Fix for {rule}, {guard}': 'Correction pour {rule}, {guard}',
  'Fix remaining breaches': 'Corriger les manquements restants',
  'Fix roster breaches': 'Corriger les manquements du planning',
  'Fix suggestions could not be loaded': 'Impossible de charger les suggestions de correction',
  'Fixes this and {count} other breach': 'Corrige ce manquement et {count} autre',
  'Fixes this and {count} other breaches': 'Corrige ce manquement et {count} autres',
  'Fixes this breach': 'Corrige ce manquement',
  'Fixes this, but adds {count} new breach': 'Corrige ce manquement, mais en crée {count} nouveau',
  'Fixes this, but adds {count} new breaches': 'Corrige ce manquement, mais en crée {count} nouveaux',
  'Fixes: {issue}': 'Corrige : {issue}',
  'Give the shift to {guard}': 'Confier la vacation à {guard}',
  'Hide the affected roster': 'Masquer le planning concerné',
  'Joins onto a {hours} shift': 'S’ajoute à une vacation de {hours}',
  'Leave as is': 'Laisser tel quel',
  'Marked available': 'Indiqué disponible',
  'New': 'Nouveau',
  'Night shift too long': 'Vacation de nuit trop longue',
  'Night-work daily average over the limit': 'Moyenne quotidienne de travail de nuit au-dessus de la limite',
  'Night-work weekly average over the limit': 'Moyenne hebdomadaire de travail de nuit au-dessus de la limite',
  'No guard can lawfully take this work. Adjust the roster on the board.':
    'Aucun agent ne peut reprendre ce travail en respectant les règles. Ajustez le planning sur le tableau.',
  'None of the possible changes passes the rules. Adjust the roster on the board.':
    'Aucune des modifications possibles ne respecte les règles. Ajustez le planning sur le tableau.',
  'Not enough rest between shifts': 'Repos insuffisant entre deux vacations',
  'Nothing else rostered this week': 'Rien d’autre de planifié cette semaine',
  'Not rostered': 'Non planifié',
  'Nothing was changed': 'Aucune modification n’a été effectuée',
  'One uninterrupted break instead of the shorter one rostered — some rules require it unbroken.':
    'Une seule pause ininterrompue à la place de la pause plus courte planifiée — certaines règles exigent qu’elle soit continue.',
  'Pick a fix for each, then review the changes before anything is saved.':
    'Choisissez une correction pour chacun, puis vérifiez les modifications avant tout enregistrement.',
  'Placed mid-shift and clear of colleagues on the same post, so it stays covered.':
    'Placée en milieu de vacation, sans chevaucher les pauses des collègues du même poste, qui reste ainsi couvert.',
  'Prefers this time': 'Préfère ce créneau',
  'Publish roster': 'Publier le planning',
  'Recommended': 'Recommandé',
  'Regulation': 'Réglementation',
  'Replace it with one {duration} break at {range}': 'La remplacer par une pause de {duration} ({range})',
  'Review and confirm': 'Vérifier et confirmer',
  'Review changes': 'Vérifier les modifications',
  'Roster fixes applied - changed duties are drafts until published':
    'Corrections appliquées — les services modifiés restent en brouillon jusqu’à la publication',
  'Shift too long': 'Vacation trop longue',
  'Show {count} more option': 'Afficher {count} autre option',
  'Show {count} more options': 'Afficher {count} autres options',
  'Steps': 'Étapes',
  'Suggest fixes': 'Proposer des corrections',
  'The break at {range} moves from {from} to {to}': 'La pause de {range} passe de {from} à {to}',
  'The changed duties are drafts until you publish the day.':
    'Les services modifiés restent en brouillon jusqu’à la publication de la journée.',
  'The roster is now within the rules': 'Le planning respecte désormais les règles',
  'The roster may have changed. Go back and refresh the suggestions.':
    'Le planning a peut-être changé. Revenez en arrière et actualisez les suggestions.',
  'The shifts involved are on another roster. Open that site and day to fix it there.':
    'Les vacations concernées figurent sur un autre planning. Ouvrez ce site et cette journée pour corriger.',
  'There is no automatic fix for this rule yet. Adjust the roster on the board.':
    'Aucune correction automatique n’existe encore pour cette règle. Ajustez le planning sur le tableau.',
  'There is nothing to fix. You can publish the day.': 'Rien à corriger. Vous pouvez publier la journée.',
  'These changes cannot be applied as they stand': 'Ces modifications ne peuvent pas être appliquées en l’état',
  'These changes clear every breach on this roster': 'Ces modifications résolvent tous les manquements de ce planning',
  'This roster is within the rules': 'Ce planning respecte les règles',
  'Too many days in a row': 'Trop de jours consécutifs',
  'Use recommended fixes': 'Utiliser les corrections recommandées',
  'View the affected roster': 'Voir le planning concerné',
  'Worked this site {count} time recently': 'A travaillé {count} fois sur ce site récemment',
  'Worked this site {count} times recently': 'A travaillé {count} fois sur ce site récemment',
  'Working out fixes…': 'Recherche de corrections…',
  'Your fix for {issues} was set aside because it changes the same guard’s day. Apply this one first, then fix what remains.':
    'Votre correction pour {issues} a été écartée, car elle modifie la journée du même agent. Appliquez d’abord celle-ci, puis corrigez ce qui reste.',
  'a duty': 'un service',
  'break {range}': 'pause {range}',
  'this region': 'cette région',
  '{count} breach on this roster.': '{count} manquement sur ce planning.',
  '{count} breaches on this roster.': '{count} manquements sur ce planning.',
  '{count} breach will remain after these changes': '{count} manquement subsistera après ces modifications',
  '{count} breaches will remain after these changes': '{count} manquements subsisteront après ces modifications',
  '{count} change to this roster': '{count} modification de ce planning',
  '{count} changes to this roster': '{count} modifications de ce planning',
  '{count} change was applied.': '{count} modification a été appliquée.',
  '{count} changes were applied.': '{count} modifications ont été appliquées.',
  '{count} fix selected': '{count} correction sélectionnée',
  '{count} fixes selected': '{count} corrections sélectionnées',
  '{count} guard': '{count} agent',
  '{count} guards': '{count} agents',
  '{date} breaches the active {country} roster rules. Review the suggested fixes, or override and keep the warning flagged for admins.':
    '{date} enfreint les règles de planning en vigueur ({country}). Examinez les corrections proposées, ou passez outre en conservant l’avertissement signalé aux administrateurs.',
  '{duty} splits at {time}: {guard} keeps {kept}, {other} covers {released}':
    '{duty} est scindé à {time} : {guard} conserve {kept}, {other} couvre {released}',
  '{duty} splits at {time}: {guard} keeps {kept}, {released} is left open':
    '{duty} est scindé à {time} : {guard} conserve {kept}, {released} reste à pourvoir',
  '{duty} {range}': '{duty} {range}',
  '{guard} comes off {duty} ({range}); the place is left open':
    '{guard} est retiré de {duty} ({range}) ; la place reste à pourvoir',
  '{guard} finishes at {time}; {other} takes over': '{guard} termine à {time} ; {other} prend le relais',
  '{guard} finishes earlier, at {time}': '{guard} termine plus tôt, à {time}',
  '{guard} gets a {duration} break at {range}': '{guard} obtient une pause de {duration} ({range})',
  '{guard} gets a {duration} paid break at {range}': '{guard} obtient une pause rémunérée de {duration} ({range})',
  '{guard} no longer takes the break at {range}': '{guard} ne prend plus la pause de {range}',
  '{guard} starts at {time}; {other} covers before': '{guard} commence à {time} ; {other} assure la couverture avant',
  '{guard} starts later, at {time}': '{guard} commence plus tard, à {time}',
  '{hours} rest after': '{hours} de repos après',
  '{hours} rest before': '{hours} de repos avant',
  '{hours} rostered this week': '{hours} planifiées cette semaine',
  '{h}h': '{h} h',
  '{h}h {m}m': '{h} h {m} min',
  '{label}: not rostered': '{label} : non planifié',
  '{m}m': '{m} min',
  '{other} covers {range}.': '{other} couvre {range}.',
  '{other} works {range} instead of {guard}.': '{other} assure {range} à la place de {guard}.',
  '{range} is left uncovered on the board.': '{range} reste sans couverture sur le tableau.',
  '{rule} ({guard})': '{rule} ({guard})',
  '{to} takes {duty} ({range}) from {from}': '{to} reprend {duty} ({range}) à la place de {from}',
  'Above band': 'Au-dessus de la tranche',
  'Add {count} open post': 'Ajouter {count} poste ouvert',
  'Add {count} open posts': 'Ajouter {count} postes ouverts',
  'Add {count} shift as drafts': 'Ajouter {count} vacation en brouillon',
  'Add {count} shifts as drafts': 'Ajouter {count} vacations en brouillon',
  'Auto schedule': 'Planification automatique',
  'Auto schedule added {count} shift as a draft': 'La planification automatique a ajouté {count} vacation en brouillon',
  'Auto schedule added {count} shifts as drafts': 'La planification automatique a ajouté {count} vacations en brouillon',
  'Below contract': 'Sous le contrat',
  'Below contract so far': 'Sous le contrat pour l’instant',
  'Break {time}': 'Pause {time}',
  'Checked against {rule}, plus licences, leave, availability and double-booking.': 'Vérifié selon {rule}, ainsi que les licences, les congés, les disponibilités et les doubles affectations.',
  'Contract': 'Contrat',
  'Day by day': 'Jour par jour',
  'Days in the past or already published are left alone.': 'Les jours passés ou déjà publiés ne sont pas modifiés.',
  'Draft schedule': 'Préparer le planning',
  'Drafted': 'En brouillon',
  'Drafting the roster…': 'Préparation du planning…',
  'Drafting…': 'Préparation…',
  'Every drafted shift is within the roster rules': 'Chaque vacation préparée respecte les règles du planning',
  'Every shift is checked against the roster rules before you see it.': 'Chaque vacation est vérifiée selon les règles du planning avant de vous être présentée.',
  'Everything was saved as a draft. Publish each day from the board when you are ready; publishing checks the rules again.': 'Tout a été enregistré en brouillon. Publiez chaque jour depuis le tableau lorsque vous êtes prêt ; la publication vérifie à nouveau les règles.',
  'Fills open places on draft duties already on the board. Nothing already rostered is moved or removed.': 'Pourvoit les places libres des services en brouillon déjà sur le tableau. Rien de ce qui est déjà planifié n’est déplacé ni supprimé.',
  'Gives guards at least the bottom of their contracted hours where it can.': 'Donne aux agents au moins le bas de leur tranche d’heures contractuelles lorsque c’est possible.',
  'Hours against contract': 'Heures par rapport au contrat',
  'Left open': 'Restées ouvertes',
  'Licences, leave, availability and double-booking were still checked, and the draft keeps to 11 hours rest, 12-hour shifts and 6 days in a row.': 'Les licences, les congés, les disponibilités et les doubles affectations ont tout de même été vérifiés, et le brouillon s’en tient à 11 heures de repos, des vacations de 12 heures et 6 jours consécutifs.',
  'Month': 'Mois',
  'New static post': 'Nouveau poste fixe',
  'No break owed': 'Aucune pause due',
  'No roster rules are set up for {country}': 'Aucune règle de planning n’est configurée pour {country}',
  'Nobody available could work these without breaking a rule, so they are drafted as open posts. Fill them on the board, or run auto schedule again once more guards are free.': 'Aucun agent disponible ne pouvait les assurer sans enfreindre une règle : ils sont donc créés comme postes ouverts. Pourvoyez-les sur le tableau, ou relancez la planification automatique lorsque davantage d’agents seront libres.',
  'Nobody can work this shift lawfully as it stands: it is too long, or its break cannot be placed.': 'Personne ne peut assurer cette vacation en l’état sans enfreindre la loi : elle est trop longue, ou sa pause ne peut pas être placée.',
  'Nothing was saved': 'Rien n’a été enregistré',
  'Only gives a shift to a guard who holds the licence, is not on leave or unavailable, and stays within every roster rule. A shift nobody can work lawfully is left open.': 'N’attribue une vacation qu’à un agent qui détient la licence, n’est ni en congé ni indisponible et respecte toutes les règles du planning. Une vacation que personne ne peut assurer légalement reste ouverte.',
  'Open||open shift': 'Ouverte',
  'Part of this week is outside the period, so its totals can still grow.': 'Une partie de cette semaine est hors de la période : ses totaux peuvent encore augmenter.',
  'Preferred shift length': 'Durée de vacation souhaitée',
  'Saved as drafts. Guards see nothing until you publish.': 'Enregistré en brouillon. Les agents ne voient rien tant que vous n’avez pas publié.',
  'Shifts are cut as close to this as the coverage window and the rules allow.': 'Les vacations sont découpées au plus près de cette durée, dans les limites de la plage de couverture et des règles.',
  'Shifts assigned': 'Vacations attribuées',
  'Standing': 'Situation',
  'The draft could not be checked clean against the roster rules, so nothing is proposed. Try a shorter period, or fix the breaches already on the board first.': 'Le brouillon n’a pas pu être validé selon les règles du planning : rien n’est donc proposé. Essayez une période plus courte, ou corrigez d’abord les infractions déjà présentes sur le tableau.',
  'The roster changed while you were reviewing, and this draft no longer fits the rules. Nothing was saved. Draft it again.': 'Le planning a changé pendant votre vérification et ce brouillon ne respecte plus les règles. Rien n’a été enregistré. Préparez-le à nouveau.',
  'The schedule could not be drafted': 'Le planning n’a pas pu être préparé',
  'The schedule could not be drafted.': 'Le planning n’a pas pu être préparé.',
  'The schedule could not be saved.': 'Le planning n’a pas pu être enregistré.',
  'There are no active guards to choose from.': 'Aucun agent actif n’est disponible.',
  'There is nothing to draft for this period': 'Il n’y a rien à préparer pour cette période',
  'Week of {date}': 'Semaine du {date}',
  'Week total': 'Total de la semaine',
  'Within band': 'Dans la tranche',
  'this site': 'ce site',
  '{count} at their limit of days in a row': '{count} à sa limite de jours consécutifs',
  '{count} at their night-work limit': '{count} à sa limite de travail de nuit',
  '{count} at their weekly hours limit': '{count} à sa limite d’heures hebdomadaires',
  '{count} cannot work it': '{count} ne peut pas l’assurer',
  '{count} day is already fully rostered.': '{count} jour est déjà entièrement planifié.',
  '{count} day is already published. Unlock it on the board to change it.': '{count} jour est déjà publié. Déverrouillez-le sur le tableau pour le modifier.',
  '{count} day is in the past and was left alone.': '{count} jour est passé et n’a pas été modifié.',
  '{count} days are already fully rostered.': '{count} jours sont déjà entièrement planifiés.',
  '{count} days are already published. Unlock them on the board to change them.': '{count} jours sont déjà publiés. Déverrouillez-les sur le tableau pour les modifier.',
  '{count} days are in the past and were left alone.': '{count} jours sont passés et n’ont pas été modifiés.',
  '{count} bound to other sites': '{count} affecté à d’autres sites',
  'Bound to other sites': 'Affecté à d’autres sites',
  'Bound to other sites. Change where they work on their Staff profile.':
    'Affecté à d’autres sites. Modifiez ses lieux de travail depuis son profil du personnel.',
  '{count} on leave': '{count} en congé',
  '{count} refused by the rules check': '{count} refusé par la vérification des règles',
  '{count} shift': '{count} vacation',
  '{count} shift added to the roster': '{count} vacation ajoutée au planning',
  '{count} shift is left open': '{count} vacation reste ouverte',
  '{count} shifts added to the roster': '{count} vacations ajoutées au planning',
  '{count} shifts are left open': '{count} vacations restent ouvertes',
  '{count} unavailable': '{count} indisponible',
  '{count} without the licence': '{count} sans la licence',
  '{count} working elsewhere': '{count} en poste ailleurs',
  '{count} would be short of rest': '{count} n’aurait pas assez de repos',
  '{hours} hours': '{hours} heures',
  '{min}-{max}h': '{min}-{max} h',
  'Across {count} site.': 'Sur {count} site.',
  'Across {count} sites.': 'Sur {count} sites.',
  'By site': 'Par site',
  'Choose sites and period': 'Choisir les sites et la période',
  'Choose up to {max} sites at a time.': 'Choisissez au plus {max} sites à la fois.',
  'Days left alone': 'Jours non modifiés',
  'Draft a fully staffed, rule-checked roster for one site or many, for a day, week or month': 'Préparer un planning complet et conforme aux règles pour un ou plusieurs sites, sur un jour, une semaine ou un mois',
  'Drafts blank static posts across each site’s coverage window, one row for each guard the site needs.': 'Crée des postes fixes vierges sur la plage de couverture de chaque site, une ligne pour chaque agent dont le site a besoin.',
  'No client': 'Sans client',
  'No roster rules cover {sites}': 'Aucune règle de planning ne couvre {sites}',
  'No sites match.': 'Aucun site ne correspond.',
  'Search sites or clients': 'Rechercher un site ou un client',
  'Select all': 'Tout sélectionner',
  'That is {count} site-days. Draft up to {max} at a time: choose fewer sites or a shorter period.': 'Cela représente {count} jours-sites. Préparez-en au plus {max} à la fois : choisissez moins de sites ou une période plus courte.',
  'The sites are planned together from one pool of guards, so rest between sites and contracted hours balance across all of them.': 'Les sites sont planifiés ensemble à partir d’un même groupe d’agents : le repos entre les sites et les heures contractuelles s’équilibrent sur l’ensemble.',
  '{selected} of {total} sites selected': '{selected} sur {total} sites sélectionnés',
  'That was too much to check in one go, so nothing was saved. Choose fewer sites or a shorter period and try again.': 'C’était trop à vérifier en une seule fois : rien n’a été enregistré. Choisissez moins de sites ou une période plus courte, puis réessayez.',
};
